import { z } from "zod";

export const prescriberSchema = () => {
  return z.object({
    user: z.number().min(1),
    board_code: z.string().optional().nullable(),
    board_number: z.string().min(1),
    board_state: z.string().min(1),
    amigobot_doctor_id: z.number().optional().nullable(),
  });
};

export type PrescriberFormValues = z.infer<ReturnType<typeof prescriberSchema>>;
